import React from 'react';

export default function Loader({ showSkeleton = true, skeletonCount = 3 }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-center py-8">
        <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-8 w-8" />
      </div>
      {showSkeleton && Array.from({ length: skeletonCount }).map((_, i) => (
        <div key={i} className="bg-white rounded-xl shadow p-4 flex flex-col md:flex-row justify-between items-start md:items-center animate-pulse">
          <div className="space-y-2 w-3/4">
            <div className="h-4 bg-gray-200 rounded w-1/3" />
            <div className="h-3 bg-gray-200 rounded w-1/2" />
            <div className="h-3 bg-gray-200 rounded w-1/4" />
          </div>
          <div className="mt-2 md:mt-0 flex gap-2">
            <div className="h-8 w-20 bg-gray-200 rounded" />
          </div>
        </div>
      ))}
      <style>{`.loader { border-top-color: #6366f1; -webkit-animation: spin 1s linear infinite; animation: spin 1s linear infinite; } @-webkit-keyframes spin { 0% { -webkit-transform: rotate(0deg);} 100% { -webkit-transform: rotate(360deg);} } @keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}</style>
    </div>
  );
}
